module.exports = __webpack_public_path__ + "static/personaggi_logo-3ed6c3a477595180b1134ee2ff7dbe20.png";